<template>
  <div class="view-container">
    <div class="extended-filter-block">
      <div class="group-name-block">
        <h2 v-if="currentGroup?.name">{{ cutString(currentGroup.name, 13) }}</h2>
      </div>
      <div class="extended-search-block-mobile">
        <div class="search-outline-block">
          <SearchOutlined @click="showMobileFilterModal = true" style="color: rgba(0, 0, 0, 0.45)" />
          <div v-if="filterString" class="dot"></div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="menu-block">
        <div class="main-group-menu-block">
          <div class="control-button">
            <a-button @click="() => showModal('manage_access', null, true)">
              Управлять доступами
            </a-button>
          </div>
          <div v-if="currentWidth > 600" class="control-button">
            <a-button @click="() => showModal('add_user')">
              <template #icon>
                <PlusOutlined />
              </template>
              Добавить Сотрудника
            </a-button>
          </div>
          <div v-if="currentWidth > 768" class="control-button">
            <a-button @click="() => showModal('edit')">
              Редактировать
            </a-button>
          </div>

          <div class="group-action-wrapper">
            <a-dropdown :trigger="['click']" placement="bottomLeft">
              <a-button type="text" @click.prevent>
                <MoreOutlined class="more-button" />
              </a-button>

              <template #overlay>
                <a-menu @click="({key}) => showModal(key)">
                  <a-menu-item v-if="currentWidth < 768" key="edit">Редактировать</a-menu-item>
                  <a-menu-item v-if="currentWidth < 600" key="add_user">Добавить сотрудника</a-menu-item>
                  <a-menu-item key="copy">Создать копию</a-menu-item>
                  <a-menu-item key="delete">Удалить</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </div>

        <div v-if="currentWidth > 600" class="control-button">
          <a-button @click="() => {}">
            <template #icon>
              <DownloadOutlined />
            </template>
            Экспорт
          </a-button>
        </div>
      </div>

      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="userData"
          :scroll="{ x: scrollX }"
          :row-selection="{ selectedRowKeys: selectedUsers, onChange: onSelectChange }"
          :pagination="false"
          :loading="tableLoading"
          @change="handleTableChange"
          :table-layout="'fixed'"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'name'">
            <a class="staff-link" @click="router.push(`/staff/${record.id}/edit`)">{{ text }}</a>
          </template>

          <template v-if="column.dataIndex === 'groups'">
            <a-tag v-for="(group) in record.groups" :key="group.id">
              {{ group.name }}
            </a-tag>
          </template>

          <template v-if="column.dataIndex === 'status'">
            <a-tag color="green" v-if="record.status === 'active'">
              Работает
            </a-tag>
            <a-tag color="red" v-else>
              В архиве
            </a-tag>
          </template>

          <template v-if="column.dataIndex === 'action'">
            <a-dropdown :trigger="['click']" placement="bottomLeft">
              <a-button type="text" @click.prevent>
                <MenuOutlined />
              </a-button>

              <template #overlay>
                <a-menu @click="({key}) => showModal(key, record)">
                  <a-menu-item key="groups">Настроить группы</a-menu-item>
                  <a-menu-item key="reset_password">Сбросить пароль</a-menu-item>
                  <a-menu-item key="manage_access">Управлять доступами</a-menu-item>
                  <a-menu-item key="edit_staff">Редактировать</a-menu-item>
                  <a-menu-item key="invite">Отправить приглашение</a-menu-item>
                  <a-menu-item v-if="record.status ==='active'" key="block">Архивировать</a-menu-item>
                  <a-menu-item v-else key="unblock">Разблокировать</a-menu-item>
                  <a-menu-item key="export">Экспортировать</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </template>

        <template #emptyText>
          <div class="no-data-wrapper">
            <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>

            <div class="no-data-text">
              {{
                filterString
                    ? 'Нет данных для отображения. Измените фильтры или запрос.'
                    : 'Нет данных для отображения. Добавьте сотрудников, чтобы начать работу.'
              }}
            </div>

            <a-button
                v-if="filterString"
                @click="resetFilters"
            >
              <template #icon>
                <ReloadOutlined />
              </template>
              Сбросить фильтры
            </a-button>

            <a-button
                v-else
                @click="() => showModal('edit')"
            >
              <template #icon>
                <PlusOutlined />
              </template>
              Добавить
            </a-button>
          </div>
        </template>
      </a-table>

      <div class="bottom-container">
        <div class="action-block">
          <div class="action-select-wrapper">
            <a-select
                v-model:value="actionToApply"
                :placeholder="'Выберите действие'"
                style="width: 100%;"
                @change="() => showModal(actionToApply)"
                :not-found-content="'Нет данных'"
                :disabled="!selectedUsers.length"
            >
              <a-select-option v-for="e in actions" :key="e.id" :value="e.id">
                {{ e.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <a-pagination v-model:current="currentPage"
                      :page-size="entitiesPerPage"
                      :buildOptionText="(count) => `${count.value} / стр`"
                      :show-total
                          ="total => `Всего ${total ?? 0} элементов`"
                      :total="totalUsers"
                      @change="handlePageChange"
        />
      </div>
    </div>

    <UsersFilterMobileForm
        v-if="showMobileFilterModal"
        :open="showMobileFilterModal"
        @close="showMobileFilterModal = false"
        :groups="groups"
        :currentGroupId="currentGroup?.id"
    />

    <EditGroupForm
        v-if="currentAction === 'edit'"
        :open="currentAction === 'edit'"
        :currentGroup="currentGroup"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <AddUsersToGroup
        v-if="currentAction === 'add_user'"
        :open="currentAction === 'add_user'"
        :currentGroup="currentGroup"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <DeleteGroupForm
        v-if="currentAction === 'delete'"
        :open="currentAction === 'delete'"
        :currentGroup="currentGroup"
        @submitted="() => router.push('/groups')"
        @close="clearCurrentUserAndAction"
    />

    <CopyGroup
        v-if="currentAction === 'copy'"
        :open="currentAction === 'copy'"
        :currentGroupId="currentGroup.id"
        :name="(currentGroup.name + ' - ' + 'Копия')"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <ResetPasswordForm
        v-if="currentAction === 'reset_password'"
        :open="currentAction === 'reset_password'"
        :currentActionUser="currentActionUser"
        :selectedUsers="selectedUsers"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <BlockUserForm
        v-if="currentAction === 'block' || currentAction === 'unblock'"
        :open="currentAction === 'block' || currentAction === 'unblock'"
        :type="currentAction"
        :currentActionUser="currentActionUser"
        :selectedUsers="selectedUsers"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <SendInviteForm
        v-if="currentAction === 'send_invite'"
        :open="currentAction === 'send_invite'"
        :currentActionUser="currentActionUser"
        :selectedUsers="selectedUsers"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <CopyUsersIntoGroup
        v-if="currentAction === 'copy_to_group'"
       :open="currentAction === 'copy_to_group'"
       :group-list="groups"
       :users="selectedUsers"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <SyncGroupsForm
        v-if="currentAction === 'groups'"
        :open="currentAction === 'groups'"
        :groupList="groups"
        :user_groups="currentActionUser.groups"
        :user_id="currentActionUser.id"
        @submitted="fetchAfterSubmit"
        @close="clearCurrentUserAndAction"
    />

    <NewOrderForm
        v-if="showOrderForm"
        :open="showOrderForm"
        @close="showOrderForm = false"
    />

    <ManageAccessForm
        v-if="currentAction === 'manage_access'"
        @close="clearCurrentUserAndAction"
        @showStaff="() => router.push('/staff')"
        @showOrderForm="() => {
              clearCurrentUserAndAction();
              showOrderForm = true;
            }"
        :userData="manageGroupAccessUsers"
        :name="currentActionUser?.id ? currentActionUser.name : null"
        :mode="'staff'"
        :open="currentAction === 'manage_access'"
    />
  </div>
</template>

<script>
import {onBeforeMount, onBeforeUnmount, reactive, ref, watch} from "@vue/runtime-core";
import {h, onMounted} from "vue";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {computed} from "@vue/reactivity";
import { SearchOutlined, SettingOutlined, PlusOutlined, ReloadOutlined, MenuOutlined, LeftOutlined, MoreOutlined, DownloadOutlined} from '@ant-design/icons-vue'
import cutString from "@/mixins/stringHelper";
import ManageAccessForm from "@/components/Forms/Access/ManageAccessForm.vue";
import NewOrderForm from "@/views/Orders/OrderForm.vue";
import SyncGroupsForm from "@/feature/group-control/forms/SyncGroupsForm.vue";
import CopyUsersIntoGroup from "@/feature/group-control/forms/CopyUsersIntoGroup.vue";
import SendInviteForm from "@/feature/users/forms/SendInviteForm.vue";
import BlockUserForm from "@/feature/users/forms/BlockUserForm.vue";
import ResetPasswordForm from "@/feature/users/forms/ResetPasswordForm.vue";
import CopyGroup from "@/feature/group-control/forms/CopyGroup.vue";
import DeleteGroupForm from "@/feature/users/forms/DeleteGroupForm.vue";
import AddUsersToGroup from "@/feature/group-control/forms/AddUsersToGroup.vue";
import EditGroupForm from "@/feature/group-control/forms/EditGroupForm.vue";
import UsersFilterMobileForm from "@/feature/users/UsersFilterMobileForm.vue";
import {message} from "ant-design-vue";
import {useTableColumns} from "@/mixins/useTableColumns";

export default {
  name: 'new-staff-page',
  components: {
    UsersFilterMobileForm,
    EditGroupForm,
    AddUsersToGroup,
    DeleteGroupForm,
    CopyGroup,
    ResetPasswordForm,
    BlockUserForm,
    SendInviteForm,
    CopyUsersIntoGroup,
    SyncGroupsForm,
    NewOrderForm,
    ManageAccessForm,
    SearchOutlined, SettingOutlined, PlusOutlined, ReloadOutlined, MenuOutlined, LeftOutlined, MoreOutlined, DownloadOutlined},
  setup() {

    const store = useStore(),
        route = useRoute(),
        router = useRouter();

    const applyToAll = ref(false);
    const actionToApply = ref();
    const tableLoading = ref(true);
    const groupsLoading = ref(true);
    const showMobileFilterModal = ref(false);

    const currentGroup = computed(() => store.state.group.group.group);
    const allGroups = computed(() => store.state.group.groups);

    const groups = ref([]);

    const showOrderForm = ref(false);

    const selectedUsers = ref([]);
    const users = computed(() => store.state.users.users);
    const userData = computed(() => {
      return users.value.map((staff) => {
        return {
          id: staff.id,
          name: staff.name,
          email: staff.email,
          job_title: staff?.job_title ?? '',
          division: staff?.division ?? '',
          telephone: staff?.telephone ?? '',
          status: staff?.is_active ? 'active' : 'not_active',
          online_from: staff.online_from,
          created_at: staff.created_at,
          groups: staff.groups,
        };
      })
    });

    const currentActionUser = ref();

    const showFilterModal = ref(false);

    const entitiesPerPage = ref(10);
    const currentPage = ref(1);
    const totalUsers = computed(() => store.state.users.totalUsers);

    const filters = computed(() => store.state.users.filters);
    const filterString = computed(() => store.state.users.filterString);

    const initialColumns = ref([
      {
        title: 'ID',
        dataIndex: 'id',
        width: 80,
        sorter: true,
        visible: true,
        align: 'left',
      },
      {
        title: 'ФИО',
        dataIndex: 'name',
        sorter: true,
        visible: true,
        width: 250,
      },
      {
        title: 'Должность',
        dataIndex: 'job_title',
        sorter: true,
        visible: true,
        width: 150,
      },
      {
        title: 'Группы',
        dataIndex: 'groups',
        visible: true,
        width: 250,
      },
      {
        title: 'Почта',
        dataIndex: 'email',
        sorter: true,
        visible: true,
        width: 180,
      },
      {
        title: 'Телефон',
        dataIndex: 'telephone',
        sorter: true,
        visible: true,
        width: 150,
      },
      {
        title: 'Отдел',
        dataIndex: 'department',
        sorter: true,
        visible: true,
        width: 150,
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        visible: true,
        width: 150,
      },
      {
        title: 'Дата добавления',
        dataIndex: 'created_at',
        sorter: true,
        visible: true,
        width: 150,
      },
      {
        title: 'Последний вход',
        dataIndex: 'online_from',
        sorter: true,
        visible: true,
        width: 150,
      },
    ]);

    const { columns, scrollX } = useTableColumns(initialColumns, {tableKey: 'group', settingsWidth: 40})

    const actions = [
      {
        id: 'copy_to_group',
        name: 'Копировать в группу'
      },
      {
        id: 'reset_password',
        name: 'Сбросить пароль'
      },
      {
        id: 'manage_access',
        name: 'Управлять доступами'
      },
      {
        id: 'send_invite',
        name: 'Отправить приглашения'
      },
      {
        id: 'block',
        name: 'Архивировать'
      },
      {
        id: 'export',
        name: 'Экспортировать'
      },
    ];

    const fetchUsers = () => {
      tableLoading.value = true;

      store.dispatch("users/getStaff", {
        per_page: entitiesPerPage.value,
        page: currentPage.value,
        sort_field: sortState.value.field,
        sort_direction:
            sortState.value.order === 'ascend'
                ? 'asc'
                : sortState.value.order === 'descend'
                    ? 'desc'
                    : null,
        ...filters.value,
        current_group: route.params.id,
      }).then(() => {
        tableLoading.value = false;
      });
    }

    const onSelectChange = selectedRowKeys => {
      selectedUsers.value = selectedRowKeys;
    };

    // фильтры
    const openFilterModal = () => {
      showFilterModal.value = true;
    }

    const updateFilters = () => {
      showMobileFilterModal.value = false;

      currentPage.value = 1;
      fetchUsers();
    }

    const resetFilters = () => {
      store.dispatch('users/setUserFilters', {
        filters: {
          name: '',
          job_title: '',
          department: '',
          online_from: '',
          created_at: '',
          email: '',
          telephone: '',
          groups: [],
          without_group_only: false,
        },
        filterString: null,
      });

      currentPage.value = 1;
      fetchUsers();
    }

    const handleGroupSelect = () => {
      fetchUsers();
    }

    //сортировка
    const sortState = ref({
      field: null,
      order: null,
    });

    const handleTableChange = (pagination, filter, sorter) => {
      sortState.value = {
        field: sorter?.field ?? null,
        order: sorter?.order ?? null,
      };

      fetchUsers();
    }

    // пагинация
    const retrieveEntitiesPerPage = () => {
      let storageValue = localStorage.getItem('perPage');
      entitiesPerPage.value = storageValue ? Number(storageValue) : 10;
    }

    const setEntitiesPerPage = (num) => {
      localStorage.setItem('perPage', num)
    }

    const handlePageChange = (current, perPage) => {
      if (entitiesPerPage.value !== perPage) {
        entitiesPerPage.value = perPage;
        setEntitiesPerPage(entitiesPerPage.value);
      }

      currentPage.value = current;
      fetchUsers();
    }

    // actions
    const modalActionLoading = ref(false);
    const showActionModal = ref(false);
    const currentAction = ref(null);

    const manageGroupAccessUsers = ref([]);

    const showModal = (action, userObject = null, fullGroup = false) => {
      currentAction.value = action;

      if (userObject) {
        currentActionUser.value = {
          id: userObject.id,
          name: userObject.name,
          groups: userObject.groups.map((group) => {
            if (!groups.value.find((el) => el.id === group.id)) {
              groups.value.push({
                id: group.id,
                name: group.name,
              });
            }

            return group.id;
          }),
        }
      } else {
        currentActionUser.value = {
          id: null,
          name: '',
          groups: [],
        }
      }

      if (action === 'edit_staff') {
        router.push('/staff/' + userObject.id + '/edit');
        return;
      }

      if (action === 'manage_access') {
        if (fullGroup) {
          currentGroup.value.users.map((user) => {
            if (!manageGroupAccessUsers.value.find((el) => el === user.id)) {
              manageGroupAccessUsers.value.push(user.id);
            }
          });
        } else {
          manageGroupAccessUsers.value = (userObject ? [userObject.id] : selectedUsers.value);
        }
      }

      if (action === 'export') {
        exportUsers(currentActionUser.value?.id ? [currentActionUser.value.id] : selectedUsers.value);
        return;
      }

      currentAction.value = action;
      showActionModal.value = true;
    }

    const exportUsers = (data) => {
      store.dispatch('users/exportExcel', {
        users: data,
      }).finally(() => {
        currentAction.value = null;
        actionToApply.value = null;
      });

      message.info('Файл генерируется, пожалуйста, подождите')
    }

    const fetchAfterSubmit = () => {
      showActionModal.value = false;
      clearCurrentUserAndAction();
      fetchUsers();
    }

    const clearCurrentUserAndAction = () => {
      selectedUsers.value = [];
      currentAction.value = null;
      showActionModal.value = false;
      actionToApply.value = null;
      modalActionLoading.value = false;

      currentActionUser.value = {
        id: null,
        name: '',
        groups: [],
      }

      manageGroupAccessUsers.value = [];
    }

    const userOptions = ref([]);

    const fillUsers = () => {
      userOptions.value =  currentGroup?.value.users?.map(user => {
        return {
          value: user.id,
          label: `${user.name} (${user.email})`,
        }
      });
    }

    onBeforeMount(() => {
      let currentGroupId = route.params.id;

      store.dispatch("group/getGroup", currentGroupId)
          .then(() => {
            fillUsers();
          });

      store.dispatch("group/getGroups").then(() => {
        groups.value = allGroups.value.map((group) => {
          return {
            id: group.id,
            name: group.name,
          }
        });

        groupsLoading.value = false;
      });

      retrieveEntitiesPerPage();
      fetchUsers();
    });

    const currentWidth = ref(window.innerWidth)
    const isMobile = ref(currentWidth.value < 768)

    const onResize = () => {
      isMobile.value = window.innerWidth < 768;
      currentWidth.value = window.innerWidth;
    }

    onMounted(() => {
      window.addEventListener('resize', onResize);
    });

    watch(filters, () => {
          updateFilters();
        },
        { deep: true, immediate: true }
    );

    onBeforeUnmount(() => {
      store.dispatch('users/setUserFilters', {
        filters: {
          name: '',
          job_title: '',
          department: '',
          online_from: '',
          current_group: null,
          created_at: '',
          email: '',
          telephone: '',
          groups: [],
          without_group_only: false,
        },
        filterString: null,
      });
    });

    return {
      cutString,
      router,
      NotFoundIcon,
      currentPage,
      entitiesPerPage,
      columns,
      applyToAll,
      actionToApply,
      currentAction,
      actions,
      groups,
      currentGroup,
      filters,
      selectedUsers,
      onSelectChange,
      resetFilters,
      tableLoading,
      showFilterModal,
      openFilterModal,
      groupsLoading,
      updateFilters,
      userData,
      currentActionUser,
      totalUsers,
      handlePageChange,
      showMobileFilterModal,
      handleTableChange,
      handleGroupSelect,
      userOptions,
      modalActionLoading,
      clearCurrentUserAndAction,
      showModal,
      showActionModal,
      isMobile,
      currentWidth,
      manageGroupAccessUsers,
      showOrderForm,
      fetchAfterSubmit,
      filterString,
      scrollX
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  min-height: 75vh;
}

.view-container {
  padding-top: 0;
  padding-bottom: 0;
}

:deep(.card .ant-table-content) {
  min-height: 60vh;
}

.filter-block {
  display: flex;
  column-gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  row-gap: 15px;
}

:deep(.ant-table-wrapper .ant-table-thead >tr>th) {
  padding: 5px;
}

:deep(.ant-table-wrapper .ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

.action-select-wrapper {
  min-width: 180px;

  @media (max-width: $mobile-breakpoint) {
    width: 100%;

    .ant-select {
      width: 100%;
    }
  }
}

.action-checkbox-wrapper {
  min-width: 200px;
}

.no-data-text {
  color: var(--main-font);
}

.add-button {
  margin-left: auto;

  @media (max-width: 550px) {
    width: 100%;

    button {
      width: 100%;
    }
  }
}

.search-tool-block {
  @media (max-width: 550px) {
    width: 100%;
  }
}

.search-tool-block .ant-select {
  width: 350px;

  @media (max-width: 550px) {
    width: 100%;
  }
}

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 0;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
}

.extended-search-block {
  display: flex;
  align-items: center;
  column-gap: 10px;
  width: 300px;

  @media (max-width: 768px) {
    display: none;
  }
}

.extended-search-block-mobile {
  display: none;
  margin-right: 10px;

  @media(max-width: 768px) {
    display: block;
  }
}

:deep(.anticon-reload) {
  cursor: pointer;
}

:deep(.anticon-reload:hover) {
  color: var(--main-green) !important;
}

.add-button button:hover,
.control-button:hover button {
  color: var(--hover-green);
  border-color: var(--hover-green);
}

.control-button button:active {
  color: var(--active-green);
  border-color: var(--active-green);
}

.no-data-wrapper {
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 5px;
  padding: 24px;
}

.no-data-wrapper button {
  margin-top: 10px;
}

.no-data-wrapper button:hover {
  border-color: var(--hover-green);
  color: var(--hover-green);
}

.no-data-wrapper button:focus,
.no-data-wrapper button:active {
  border-color: var(--active-green);
  color: var(--active-green);
}

@media (max-width: $mobile-breakpoint) {
  :deep(.ant-pagination .ant-pagination-total-text ) {
    display: none !important;
  }
}

:deep(.ant-input-focused) {
  border-color: var(--active-green);
}

.ant-input-affix-wrapper:hover,
.ant-input-affix-wrapper-focused {
  border-color: var(--main-green);
}

.ant-input-affix-wrapper-focused {
  box-shadow: none;
}

.search-outline-block {
  position: relative;
}

.dot {
  position: absolute;
  top: -1px;
  left: 11px;
  height: 5px;
  width: 5px;
  background-color: var(--color-error);
  border-radius: 50%;
}

.staff-link {
  color: var(--main-green);
}

.staff-link:hover {
  color: var(--hover-green);
}

:deep(.ant-btn-text.ant-dropdown-trigger) {
  color: lightgrey;
}

:deep(.ant-btn-text.ant-dropdown-trigger.ant-dropdown-open) {
  color: var(--main-font);
}

:deep(.group-action-wrapper .ant-btn-text:not(:disabled):hover) {
  background-color: unset;
}

:deep(.ant-table-tbody .ant-dropdown-trigger) {
  padding: 4px 5px !important;
}

:deep(.ant-table-wrapper .ant-table-tbody >tr.ant-table-row-selected >td) {
  background-color: var(--light-grey);
}

:deep(.ant-table-wrapper .ant-table-tbody >tr.ant-table-row-selected:hover>td) {
  background-color: var(--light-grey);
}

.group-action-wrapper {
  border: 1px solid #d9d9d9;

  button {
    color: var(--main-font) !important;
  }
}

.back-button-wrapper,
.group-action-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #FFFFFF;
  border-radius: 25%;
  cursor: pointer;
}

.back-button-wrapper:hover .back-button {
  color: var(--main-green);
}

.group-action-wrapper:hover {
  border-color: var(--hover-green);
}

.group-action-wrapper:hover button {
  color: var(--hover-green) !important;
}

.group-name-block {
  max-width: 150px;

  h2 {
    font-size: 16px;
  }
}

:deep(.ant-tag) {
  margin-bottom: 5px;
}

.menu-block {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  column-gap: 5px;
}

.main-group-menu-block {
  display: flex;
  column-gap: 10px;
  row-gap: 10px;

  @media (max-width: $mobile-breakpoint) {
    width: 100%;
    column-gap: 5px;

    .group-action-wrapper {
      margin-left: auto;
    }

    .control-button,
    .control-button button {
      width: 100%;
    }
  }
}

h2 {
  font-weight: 600;
  font-size: 16px;
}
</style>